module.exports = __webpack_public_path__ + "static/media/list-selected.246c25a5.svg";